import { render, staticRenderFns } from "./Freshwater.vue?vue&type=template&id=b6a60d68&"
import script from "./Freshwater.vue?vue&type=script&lang=js&"
export * from "./Freshwater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports